// LegalPage.js
// Place in /mnt/project/Screens/LegalPage.js

import { useParams, useNavigate } from 'react-router-dom';
import { Container, Title, Text, Stack, Paper, Button, List, Divider } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

export function LegalPage() {
  const { type } = useParams();
  const navigate = useNavigate();

  const getContent = () => {
    switch (type) {
      case 'terms':
        return <TermsContent />;
      case 'data-processing':
        return <DataProcessingContent />;
      case 'privacy':
        return <PrivacyContent />;
      default:
        return <NotFoundContent />;
    }
  };

  return (
    <Container size="md" py="xl">
      <Button
        leftIcon={<IconArrowLeft size={16} />}
        variant="subtle"
        mb="lg"
        onClick={() => navigate('/')}
      >
        Atpakaļ
      </Button>
      
      <Paper shadow="sm" p="xl">
        {getContent()}
      </Paper>
    </Container>
  );
}

function TermsContent() {
  return (
    <Stack spacing="md">
      <Title order={1}>Lietošanas noteikumi</Title>
      <Text size="sm" color="dimmed">
        Pēdējās izmaiņas: {new Date().toLocaleDateString('lv-LV')}
      </Text>

      <Divider my="md" />

      <Stack spacing="lg">
        <div>
          <Title order={2} size="h3" mb="sm">1. Vispārīgie noteikumi</Title>
          <Text>
            Šie lietošanas noteikumi regulē Spilve lidostas PPR (Prior Permission Required) 
            sistēmas lietošanu. Izmantojot šo sistēmu, jūs piekrītat šiem noteikumiem pilnā apjomā.
          </Text>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">2. PPR sistēmas izmantošana</Title>
          <List spacing="sm">
            <List.Item>
              Sistēmu drīkst izmantot tikai reģistrēti lietotāji ar derīgu lidmašīnas reģistrāciju
            </List.Item>
            <List.Item>
              PPR numurs ir derīgs tikai norādītajam datumam un laika periodam
            </List.Item>
            <List.Item>
              PPR pieprasījums ir jāiesniedz vismaz 24 stundas pirms plānotā lidojuma
            </List.Item>
            <List.Item>
              Lidostas administrācija patur tiesības atteikt PPR pieprasījumu pamatotu iemeslu dēļ
            </List.Item>
            <List.Item>
              PPR numurs negarantē stāvvietas pieejamību bez atsevišķa apstiprinājuma
            </List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">3. Maksājumi un atmaksas</Title>
          <Text mb="sm">
            <strong>3.1 Maksājumu veikšana:</strong>
          </Text>
          <List spacing="sm">
            <List.Item>
              Maksājumi tiek veikti tiešsaistē caur EveryPay maksājumu sistēmu
            </List.Item>
            <List.Item>
              Alternatīvi iespējams maksāt lidostā ierodoties (ja izvēlēta šī opcija)
            </List.Item>
            <List.Item>
              Cenas ir norādītas EUR un ietver PVN
            </List.Item>
          </List>

          <Text mt="md" mb="sm">
            <strong>3.2 Atmaksas politika:</strong>
          </Text>
          <List spacing="sm">
            <List.Item>
              PPR atcelšana vismaz 48 stundas pirms lidojuma - pilna atmaksa
            </List.Item>
            <List.Item>
              PPR atcelšana 24-48 stundas pirms lidojuma - 50% atmaksa
            </List.Item>
            <List.Item>
              PPR atcelšana mazāk nekā 24 stundas pirms lidojuma - atmaksa netiek veikta
            </List.Item>
            <List.Item>
              Atmaksas tiek veiktas uz to pašu maksājuma karti 5-10 darba dienu laikā
            </List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">4. Lietotāja pienākumi</Title>
          <List spacing="sm">
            <List.Item>
              Sniegt precīzu un aktuālu informāciju reģistrācijas un PPR pieprasījuma procesā
            </List.Item>
            <List.Item>
              Informēt lidostas administrāciju par būtiskām izmaiņām lidojuma plānā
            </List.Item>
            <List.Item>
              Ievērot lidostas noteikumus un aviācijas drošības prasības
            </List.Item>
            <List.Item>
              Neizpaust sistēmas piekļuves datus trešajām personām
            </List.Item>
            <List.Item>
              Izmantot sistēmu saskaņā ar tās paredzēto mērķi
            </List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">5. Atbildības ierobežojums</Title>
          <Text>
            Lidostas administrators nenes atbildību par:
          </Text>
          <List spacing="sm">
            <List.Item>
              Zaudējumiem, kas radušies sistēmas tehnisko traucējumu dēļ
            </List.Item>
            <List.Item>
              Lidojuma plāna izmaiņām, kas radušās ārēju faktoru ietekmē
            </List.Item>
            <List.Item>
              Trešo personu darbībām vai bezdarbību
            </List.Item>
            <List.Item>
              Nepārvaramas varas apstākļiem (force majeure)
            </List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">6. Noteikumu grozījumi</Title>
          <Text>
            Lidostas administrācija patur tiesības jebkurā laikā grozīt šos noteikumus. 
            Lietotāji tiks informēti par būtiskām izmaiņām pa e-pastu. Turpinot izmantot 
            sistēmu pēc izmaiņu ieviešanas, jūs piekrītat jaunajiem noteikumiem.
          </Text>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">7. Kontaktinformācija</Title>
          <Text>
            Ja jums ir jautājumi par šiem noteikumiem, lūdzu, sazinieties ar mums:
          </Text>
          <List spacing="sm">
            <List.Item>E-pasts: info@spilve.org</List.Item>
            <List.Item>Adrese: Katrīnas dambī 16A-30, Rīgā, LV-1045</List.Item>
          </List>
        </div>
      </Stack>
    </Stack>
  );
}

function DataProcessingContent() {
  return (
    <Stack spacing="md">
      <Title order={1}>Datu apstrādes noteikumi</Title>
      <Text size="sm" color="dimmed">
        Pēdējās izmaiņas: {new Date().toLocaleDateString('lv-LV')}
      </Text>

      <Divider my="md" />

      <Stack spacing="lg">
        <div>
          <Title order={2} size="h3" mb="sm">1. Datu pārzinis</Title>
          <Text>
            Spilves lidosta (turpmāk - "Lidosta") ir personu datu pārzinis attiecībā 
            uz personas datiem, kas tiek apstrādāti PPR sistēmas ietvaros.
          </Text>
          <List spacing="sm" mt="sm">
            <List.Item>Nosaukums: Nodibinājums “Lidosta Spilve”</List.Item>
            <List.Item>Reģ. Nr.: 40008272456</List.Item>
            <List.Item>Adrese: Katrīnas dambī 16A-30, Rīgā, LV-1045</List.Item>
            <List.Item>E-pasts: info@spilve.org</List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">2. Apstrādājamie personas dati</Title>
          <Text mb="sm">Mēs apstrādājam šādus personas datus:</Text>
          <List spacing="sm">
            <List.Item>
              <strong>Identifikācijas dati:</strong> vārds, uzvārds, personas kods (ja piemērojams)
            </List.Item>
            <List.Item>
              <strong>Kontaktinformācija:</strong> e-pasta adrese, tālruņa numurs
            </List.Item>
            <List.Item>
              <strong>Lidojuma informācija:</strong> lidmašīnas reģistrācijas numurs, lidojuma tips, 
              datums, laiks, maršruts
            </List.Item>
            <List.Item>
              <strong>Maksājumu dati:</strong> darījuma numurs, maksājuma statuss, summa 
              (kartes dati tiek apstrādāti maksājumu apstrādātāja - EveryPay)
            </List.Item>
            <List.Item>
              <strong>Tehniskā informācija:</strong> IP adrese, ierīces tips, pārlūkprogramma
            </List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">3. Datu apstrādes mērķi un juridiskais pamats</Title>
          <Text mb="sm">Jūsu personas datus apstrādājam šādiem mērķiem:</Text>
          
          <Stack spacing="md">
            <div>
              <Text weight={500}>3.1 PPR pieprasījumu apstrāde</Text>
              <List spacing="xs">
                <List.Item>Juridiskais pamats: Līguma izpilde</List.Item>
                <List.Item>Mērķis: Nodrošināt lidojuma atļaujas piešķiršanu un uzskaiti</List.Item>
              </List>
            </div>

            <div>
              <Text weight={500}>3.2 Maksājumu apstrāde</Text>
              <List spacing="xs">
                <List.Item>Juridiskais pamats: Līguma izpilde</List.Item>
                <List.Item>Mērķis: Apstrādāt maksājumus par PPR pakalpojumiem</List.Item>
              </List>
            </div>

            <div>
              <Text weight={500}>3.3 Aviācijas drošība</Text>
              <List spacing="xs">
                <List.Item>Juridiskais pamats: Juridisks pienākums</List.Item>
                <List.Item>Mērķis: Ievērot aviācijas drošības prasības</List.Item>
              </List>
            </div>

            <div>
              <Text weight={500}>3.4 Komunikācija ar lietotājiem</Text>
              <List spacing="xs">
                <List.Item>Juridiskais pamats: Likumīgās intereses</List.Item>
                <List.Item>Mērķis: Informēt par PPR statusu un izmaiņām</List.Item>
              </List>
            </div>
          </Stack>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">4. Datu saņēmēji</Title>
          <Text mb="sm">Jūsu personas datus varam nodot šādām trešajām personām:</Text>
          <List spacing="sm">
            <List.Item>
              <strong>EveryPay:</strong> maksājumu apstrādes pakalpojumu sniedzējs
            </List.Item>
            <List.Item>
              <strong>Civilās aviācijas aģentūra:</strong> atbilstoši aviācijas noteikumiem
            </List.Item>
            <List.Item>
              <strong>IT pakalpojumu sniedzēji:</strong> serveru uzturēšanai un sistēmas atbalstam
            </List.Item>
            <List.Item>
              <strong>Tiesībaizsardzības iestādes:</strong> uz juridiska pieprasījuma pamata
            </List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">5. Datu glabāšanas termiņi</Title>
          <List spacing="sm">
            <List.Item>
              <strong>PPR pieprasījumu dati:</strong> 3 gadi pēc lidojuma
            </List.Item>
            <List.Item>
              <strong>Maksājumu informācija:</strong> 7 gadi (atbilstoši grāmatvedības prasībām)
            </List.Item>
            <List.Item>
              <strong>Kontu dati:</strong> līdz konta dzēšanai + 1 gads
            </List.Item>
            <List.Item>
              <strong>Aviācijas drošības ieraksti:</strong> atbilstoši CAA noteikumiem (parasti 5 gadi)
            </List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">6. Jūsu tiesības</Title>
          <Text mb="sm">Saskaņā ar VDAR jums ir šādas tiesības:</Text>
          <List spacing="sm">
            <List.Item>
              <strong>Tiesības piekļūt datiem:</strong> saņemt informāciju par jūsu personas datiem
            </List.Item>
            <List.Item>
              <strong>Tiesības labot datus:</strong> labot neprecīzus vai nepilnīgus datus
            </List.Item>
            <List.Item>
              <strong>Tiesības dzēst datus:</strong> pieprasīt datu dzēšanu (ar ierobežojumiem)
            </List.Item>
            <List.Item>
              <strong>Tiesības ierobežot apstrādi:</strong> ierobežot datu apstrādi noteiktos gadījumos
            </List.Item>
            <List.Item>
              <strong>Tiesības uz datu pārnesamību:</strong> saņemt datus strukturētā formātā
            </List.Item>
            <List.Item>
              <strong>Tiesības iebilst:</strong> iebilst pret datu apstrādi likumīgo interešu gadījumā
            </List.Item>
            <List.Item>
              <strong>Tiesības iesniegt sūdzību:</strong> Datu valsts inspekcijai (www.dvi.gov.lv)
            </List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">7. Datu drošība</Title>
          <Text>
            Mēs izmantojam atbilstošus tehniskos un organizatoriskos pasākumus, lai aizsargātu 
            jūsu personas datus pret nejaušu vai nelikumīgu iznīcināšanu, zudumu, izmaiņām, 
            neatļautu izpaušanu vai piekļuvi:
          </Text>
          <List spacing="sm" mt="sm">
            <List.Item>SSL/TLS šifrēšana datu pārsūtīšanai</List.Item>
            <List.Item>Šifrēta datu glabāšana datubāzē</List.Item>
            <List.Item>Regulāras drošības audita pārbaudes</List.Item>
            <List.Item>Ierobežota piekļuve personas datiem (need-to-know princips)</List.Item>
            <List.Item>Darbinieku apmācība datu aizsardzības jomā</List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">8. Kontakti datu aizsardzības jautājumos</Title>
          <Text>
            Lai izmantotu savas tiesības vai uzdotu jautājumus par datu apstrādi:
          </Text>
          <List spacing="sm" mt="sm">
            <List.Item>E-pasts: info@spilve.org</List.Item>
            <List.Item>Adrese: Spilves lidosta, Datu aizsardzības speciālists, Rīga, LV-1058</List.Item>
          </List>
        </div>
      </Stack>
    </Stack>
  );
}

function PrivacyContent() {
  return (
    <Stack spacing="md">
      <Title order={1}>Privātuma politika</Title>
      <Text size="sm" color="dimmed">
        Pēdējās izmaiņas: {new Date().toLocaleDateString('lv-LV')}
      </Text>

      <Divider my="md" />

      <Stack spacing="lg">
        <div>
          <Title order={2} size="h3" mb="sm">1. Ievads</Title>
          <Text>
            Spilves lidosta ("mēs", "mūsu") apņemas aizsargāt jūsu privātumu. Šī privātuma 
            politika izskaidro, kā mēs vācam, izmantojam, atklājam un aizsargājam jūsu 
            informāciju, kad izmantojat mūsu PPR sistēmu.
          </Text>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">2. Informācija, ko vācam</Title>
          
          <Text weight={500} mt="md" mb="sm">2.1 Informācija, ko jūs sniedzat</Text>
          <List spacing="sm">
            <List.Item>Reģistrācijas informācija (vārds, uzvārds, e-pasts, tālrunis)</List.Item>
            <List.Item>Lidmašīnas informācija (reģistrācijas numurs, tips, svars)</List.Item>
            <List.Item>Lidojuma detaļas (datums, laiks, maršruts, mērķis)</List.Item>
            <List.Item>Maksājumu informācija (tikai darījuma ID, ne kartes dati)</List.Item>
          </List>

          <Text weight={500} mt="md" mb="sm">2.2 Automātiski vāktā informācija</Text>
          <List spacing="sm">
            <List.Item>IP adrese un atrašanās vietas dati</List.Item>
            <List.Item>Ierīces informācija (tips, operētājsistēma, pārlūks)</List.Item>
            <List.Item>Lietošanas statistika (apmeklētās lapas, lietošanas ilgums)</List.Item>
            <List.Item>Sīkdatnes un līdzīgas tehnoloģijas</List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">3. Kā izmantojam jūsu informāciju</Title>
          <List spacing="sm">
            <List.Item>PPR pieprasījumu apstrāde un lidojumu koordinācija</List.Item>
            <List.Item>Maksājumu apstrāde un finanšu uzskaite</List.Item>
            <List.Item>Komunikācija par PPR statusu un izmaiņām</List.Item>
            <List.Item>Klientu atbalsta sniegšana</List.Item>
            <List.Item>Aviācijas drošības un regulējumu ievērošana</List.Item>
            <List.Item>Statistikas analīze un pakalpojumu uzlabošana</List.Item>
            <List.Item>Juridisko pienākumu izpilde</List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">4. Sīkdatnes (Cookies)</Title>
          <Text mb="sm">
            Mūsu vietne izmanto sīkdatnes, lai uzlabotu lietošanas pieredzi:
          </Text>
          
          <Text weight={500} mt="sm" mb="xs">4.1 Obligātās sīkdatnes</Text>
          <List spacing="xs">
            <List.Item>Sesijas pārvaldība un autentifikācija</List.Item>
            <List.Item>Drošības funkcijas</List.Item>
            <List.Item>Valodas un iestatījumu atcerēšanās</List.Item>
          </List>

          <Text weight={500} mt="sm" mb="xs">4.2 Analītikas sīkdatnes</Text>
          <List spacing="xs">
            <List.Item>Apmeklējumu statistika</List.Item>
            <List.Item>Lietotāju uzvedības analīze</List.Item>
            <List.Item>Pakalpojumu uzlabošana</List.Item>
          </List>

          <Text mt="sm">
            Jūs varat pārvaldīt sīkdatņu iestatījumus savā pārlūkā. Ņemiet vērā, 
            ka obligāto sīkdatņu atspējošana var ietekmēt sistēmas funkcionalitāti.
          </Text>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">5. Informācijas koplietošana</Title>
          <Text mb="sm">
            Mēs nekoplietojam jūsu personas informāciju ar trešajām personām, 
            izņemot šādos gadījumos:
          </Text>
          <List spacing="sm">
            <List.Item>
              <strong>Pakalpojumu sniedzēji:</strong> EveryPay (maksājumi), hostinga pakalpojumi
            </List.Item>
            <List.Item>
              <strong>Juridiskas prasības:</strong> tiesībaizsardzības iestādes, tiesas
            </List.Item>
            <List.Item>
              <strong>Aviācijas iestādes:</strong> Civilās aviācijas aģentūra
            </List.Item>
            <List.Item>
              <strong>Ar jūsu piekrišanu:</strong> citās situācijās ar jūsu skaidru atļauju
            </List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">6. Datu drošība</Title>
          <Text>
            Mēs īstenojam nozares standarta drošības pasākumus:
          </Text>
          <List spacing="sm" mt="sm">
            <List.Item>256-bitu SSL šifrēšana visai datu pārsūtīšanai</List.Item>
            <List.Item>Šifrēta datu glabāšana datubāzēs</List.Item>
            <List.Item>Divfaktoru autentifikācija administratoru kontiem</List.Item>
            <List.Item>Regulāri drošības auditi un ievainojamības testi</List.Item>
            <List.Item>Ierobežota piekļuve personas datiem</List.Item>
            <List.Item>Regulāras rezerves kopijas</List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">7. Jūsu izvēles un kontrole</Title>
          <Text mb="sm">Jūs varat:</Text>
          <List spacing="sm">
            <List.Item>Piekļūt un atjaunināt savu konta informāciju</List.Item>
            <List.Item>Pieprasīt savu datu kopiju</List.Item>
            <List.Item>Dzēst savu kontu (ar noteiktiem ierobežojumiem)</List.Item>
            <List.Item>Atteikties no mārketinga e-pastiem</List.Item>
            <List.Item>Pārvaldīt sīkdatņu iestatījumus</List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">8. Bērnu privātums</Title>
          <Text>
            Mūsu pakalpojumi nav paredzēti personām, kas jaunākas par 18 gadiem. 
            Mēs apzināti nevācam personas informāciju no bērniem. Ja esat vecāks 
            vai aizbildnis un uzskatāt, ka jūsu bērns ir sniedzis mums personas 
            informāciju, lūdzu, sazinieties ar mums.
          </Text>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">9. Starptautiskā datu pārsūtīšana</Title>
          <Text>
            Jūsu informācija tiek glabāta serveros Eiropas Savienības teritorijā. 
            Ja dati tiek pārsūtīti ārpus ES, mēs nodrošinām atbilstošu aizsardzības 
            līmeni, izmantojot standarta līguma klauzulas vai citus VDAR apstiprinātu mehānismus.
          </Text>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">10. Izmaiņas privātuma politikā</Title>
          <Text>
            Mēs varam periodiski atjaunināt šo privātuma politiku. Par būtiskām izmaiņām 
            informēsim pa e-pastu vai ar paziņojumu mūsu vietnē. Privātuma politikas 
            turpmāka izmantošana pēc izmaiņu ieviešanas nozīmē jūsu piekrišanu jaunajai versijai.
          </Text>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">11. Kontaktinformācija</Title>
          <Text mb="sm">
            Ja jums ir jautājumi par šo privātuma politiku vai vēlaties izmantot 
            savas tiesības:
          </Text>
          <List spacing="sm">
            <List.Item>E-pasts: info@spilve.org</List.Item>
          </List>

          <Text mt="md">
            Jūs varat arī iesniegt sūdzību Datu valsts inspekcijai:
          </Text>
          <List spacing="sm" mt="xs">
            <List.Item>Tīmekļa vietne: www.dvi.gov.lv</List.Item>
            <List.Item>E-pasts: pasts@dvi.gov.lv</List.Item>
            <List.Item>Tālrunis: +371 67223131</List.Item>
          </List>
        </div>

        <div>
          <Title order={2} size="h3" mb="sm">12. Piekrišana</Title>
          <Text>
            Izmantojot mūsu PPR sistēmu, jūs apstiprināt, ka esat izlasījis un sapratis 
            šo privātuma politiku un piekrītat informācijas vākšanai un izmantošanai, 
            kā aprakstīts šajā dokumentā.
          </Text>
        </div>
      </Stack>
    </Stack>
  );
}

function NotFoundContent() {
  return (
    <Stack spacing="md" align="center" py="xl">
      <Title order={2}>Lapa nav atrasta</Title>
      <Text color="dimmed">Pieprasītā juridiskā lapa neeksistē.</Text>
    </Stack>
  );
}